import { render, staticRenderFns } from "./AywaPage.vue?vue&type=template&id=0fd9361e&scoped=true"
import script from "./AywaPage.vue?vue&type=script&lang=js"
export * from "./AywaPage.vue?vue&type=script&lang=js"
import style0 from "./AywaPage.vue?vue&type=style&index=0&id=0fd9361e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd9361e",
  null
  
)

export default component.exports